import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { site, genericWhatsappLink } from "@/content/liane-site.ar";
import { WhatsAppIcon } from "./WhatsAppIcon";
import lianeLogo from "@/assets/liane/liane-logo.png";

export function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors ${
        scrolled ? "border-b border-l-border bg-l-background/85 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <nav className="container-liane flex h-16 items-center justify-between gap-3">
        <a href="#home" className="flex items-center" aria-label={site.brand}>
          <img
            src={lianeLogo}
            alt={site.brand}
            width={640}
            height={262}
            className="h-9 w-auto sm:h-10"
            loading="eager"
            decoding="async"
          />
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {site.nav.links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="rounded-full px-3 py-2 text-sm text-l-muted-foreground transition-colors hover:bg-l-accent-soft hover:text-l-primary"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-1">
          <a
            href={genericWhatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={site.nav.whatsappAria}
            className="grid size-12 place-items-center rounded-full text-l-whatsapp transition-colors hover:bg-l-accent-soft"
          >
            <WhatsAppIcon className="size-6" />
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={site.nav.menuAria}
            aria-expanded={open}
            className="grid size-12 place-items-center rounded-full text-l-primary transition-colors hover:bg-l-accent-soft lg:hidden"
          >
            {open ? <X className="size-6" /> : <Menu className="size-6" />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-l-border bg-l-background/95 backdrop-blur-md lg:hidden">
          <ul className="container-liane flex flex-col py-2">
            {site.nav.links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="flex min-h-12 items-center rounded-xl px-3 text-start text-base text-l-foreground transition-colors hover:bg-l-accent-soft"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}
